module.exports = __webpack_public_path__ + "static/media/pencil.5868937c.svg";